
/**
 * 空白・nullチェック
 * @param str
 * @returns {boolean}
 */
export function isEmpty(str) {
  return str === undefined || str === null || str === "";
}

/**
 * not空白・nullチェック
 * @param str
 * @returns {boolean}
 */
export function isNotEmpty(str) {
  return !isEmpty(str);
}

/**
 * concat url or path
 * @param str1
 * @param str2
 * @param str3
 * @returns {*|string}
 */
export function concatPath(str1, str2, str3 = "") {
  let slash_str = "/";
  let slice_r = str1.slice(-1);
  let slice_l = str2.slice(0, 1);

  let concat_str;

  let str_left = str1;
  let str_right = str2;
  if(slash_str === slice_r && slash_str === slice_l) {
    // 末尾1文字を削除
    str_left = str_left.slice(0, -1);
    concat_str = str_left + str_right;
  } else if(slash_str !== slice_r && slash_str !== slice_l) {
    concat_str = str_left + slash_str + str_right;
  } else {
    concat_str = str_left + str_right;
  }
  return concat_str + str3;
}

export function concat(str1, str2) {
  if(isNotEmpty(str1) && isNotEmpty(str2)) {
    return str1 + str2;
  } else if(isNotEmpty(str1) && isEmpty(str2)) {
    return str1;
  } else if(isEmpty(str1) && isNotEmpty(str2)) {
    return str2;
  } else {
    return "";
  }
}


/**
 * equal for Number
 * @param target1 target value1
 * @param target2 target value2
 * @returns {boolean}
 */
export function equalsNumber(target1, target2) {
  let target1_num = Number(target1);
  let target2_num = Number(target2);
  if(isNaN(target1_num) || isNaN(target2_num)) {
    return false;
  }
  return target1_num === target2_num;
}

export function nullVal(val) {
  if(isEmpty(val)) {
    return "";
  } else {
    return val;
  }
}

export function val(val, initialValue) {
  if(isEmpty(val)) {
    return initialValue;
  } else {
    return val;
  }
}


/**
 * 改行をBRタグに変換
 * @param str
 * @returns {*}
 */
export function toBr(str) {
  return str.replace(/\r\n/g, "<br>").replace(/([\n\r])/g, "<br>");
}